import React from 'react';
import { Link } from 'react-router-dom';
import './header-notifications.css';

const items = [
  ['function', 'New function enquiries'],
  ['membership', 'New membership enquiries'],
  ['offer', 'Active claimed offers'],
];

export default function GalleryNotifications({ summary }) {
  if (!summary) return null;
  return <section className="header-gallery-activity" aria-label="Social Gallery activity">
        <strong>Social Gallery</strong>
        <p>New enquiries and active offers.</p>
        {items.map(([type, label]) => <Link key={type} to={`/social-gallery/leads?type=${type}${type === 'offer' ? '&status=claimed' : ''}`}>
          <span>{label}</span><b>{summary.counts[type]}</b>
        </Link>)}
  </section>;
}
